import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { tuyau } from "@/config/tuyau";
import type { CreateAvailabilityPayload } from "@/domain/availability/availability.type";

export const availabilityKeys = {
  all: ["availability"] as const,
  myAvailabilities: (date: string) =>
    [...availabilityKeys.all, "my-availabilities", date] as const,
  publicChefAvailabilities: (chefId: number, date: string) =>
    [
      ...availabilityKeys.all,
      "public-chef-availabilities",
      chefId,
      date,
    ] as const,
};

export const availabilityQueries = {
  publicChefAvailabilities: (chefId: number, date: string) =>
    queryOptions({
      queryKey: availabilityKeys.publicChefAvailabilities(chefId, date),
      queryFn: async () =>
        (
          await tuyau.availabilities.showAvailabilities({
            params: { id: chefId },
            query: { date },
          })
        ).data,
    }),

  myAvailabilities: (date: string) =>
    queryOptions({
      queryKey: availabilityKeys.myAvailabilities(date),
      queryFn: async () =>
        (await tuyau.availabilities.index({ query: { date } })).data,
      placeholderData: (previousData) => previousData,
    }),
};

export const availabilityMutations = {
  create: () =>
    mutationOptions({
      mutationFn: async (data: CreateAvailabilityPayload) =>
        await tuyau.availabilities.store({ body: data }),
    }),
};
